<template>
  <tbody v-if="expense" class="tbody">
    <tr style="height: 50px">
      <td class="text-left">
        {{ expense.accountName }}
      </td>
      <td class="text-left">
        {{ getParticulars() }}
      </td>
      <td class="text-left">
        {{ formatDate(expense.date) }}
      </td>
      <td>
        {{ formatDate(expense.affectFrom) }}
      </td>
      <!-- <td>
        {{ formatDate(expense.expiry) }}
      </td> -->
      <td>
        {{ expense.title }}
      </td>
      <!-- <td>
        {{ formatDate(expense.forMonth) }}
      </td> -->
      <td>
        {{ expense.invoiceNo }}
      </td>
      <td>
        <a
          :href="'/vehicle/' + expense.vehicle_id"
          v-if="expense.vehicleTO && expense.vehicleTO.regNo"
          >{{ expense.vehicleTO.regNo }}</a
        >
        <a
          :href="'/driver/' + expense.driver_id"
          v-if="expense.driverTO && expense.driverTO.name"
          >{{ expense.driverTO.name }}</a
        >
      </td>
      <td class="text-right">
        {{ expense.fare.total }}
      </td>
      <td class="text-right">
        {{ expense.fare.totalTaxes }}
      </td>
      <td class="text-center">
        <a
          :href="'/settings/vendor/' + expense.vendor_id"
          v-if="expense.vendor_id && expense.vendor_id != 'null'"
          >{{ expense.vendorName }}</a
        >
        <span v-if="expense.vendor_id == 'null' && expense.organization != null">{{expense.organization.name}}</span>
      </td>

      <!-- <td>
        <span v-if="expense.accountCode != 'CreditNote'">
          <span
            >{{ getDateTitle("date") }} : {{ formatDate(expense.date) }}</span
          >
          <br />
          <span
            v-if="
              expense.accountCode == 'DriverExpense' ||
              expense.accountCode == 'VehicleExpense' ||
              expense.accountCode == 'ArticlePurchase' ||
              expense.accountCode == 'OfficeExpense'
            "
            >{{ getDateTitle("affectFrom") }} : {{ formatDate(expense.affectFrom) }}
            {{ formatDate(expense.affectFrom) }}</span
          >
        </span>
      </td> -->

      <!-- <td>
        <span v-if="expense.accountCode != 'CreditNote'">
          <span
            v-if="
              expense.accountCode == 'DriverExpense' ||
              expense.accountCode == 'VehicleExpense' ||
              expense.accountCode == 'ArticlePurchase' ||
              expense.accountCode == 'OfficeExpense'
            "
            >{{ getDateTitle("expiry") }} : {{ formatDate(expense.expiry) }}<br
          /></span>
          <span
            v-if="
              expense.accountCode == 'Salary' ||
              expense.accountCode == 'SalaryAdvance' ||
              expense.accountCode == 'Rent'
            "
            >For Month :{{ formatDate(expense.forMonth) }}
          </span>
        </span>
      </td> -->

      <!-- <td>
        <span
          v-show="
            expense.accountCode != 'DriverCashAdvance' &&
            expense.accountCode != 'DriverFundReturn' &&
            expense.accountCode != 'TripExpenseAdvance' &&
            expense.accountCode != 'TripExpenseReturn' &&
            expense.accountCode != 'SupplierAdvance' &&
            expense.accountCode != 'SupplierFundReturn' &&
            expense.accountCode != 'SalaryAdvance' &&
            expense.accountCode != 'Salary'
          "
          >Bill No: {{ expense.invoiceNo }} <br />
        </span>

        <span
          v-show="
            expense.accountCode == 'DriverCashAdvance' ||
            expense.accountCode == 'DriverFundReturn' ||
            expense.accountCode == 'TripExpenseAdvance' ||
            expense.accountCode == 'TripExpenseReturn' ||
            expense.accountCode == 'SalaryAdvance' ||
            expense.accountCode == 'Salary' ||
            expense.accountCode == 'DriverExpense'
          "
        >
          {{ getTitle() }} : {{ expense.title }}
        </span>
      </td> -->

      <!-- <td>
        <span
          v-show="
            expense.accountCode == 'VehicleExpense' &&
            expense.expenseType == 'Maintenance'
          "
        >
          <span v-if="expense.kms"
            >Service Kms Reading : {{ expense.kms }}<br
          /></span>
          <span v-if="expense.nextServiceDate"
            >Next Service Date : {{ formatDate(expense.nextServiceDate) }}<br
          /></span>
          <span v-if="expense.nextServiceKM"
            >Next Service Kms : {{ expense.nextServiceKM }}</span
          >
        </span>
      </td> -->

      <!-- <td>
        <span
          v-show="
            expense.accountCode == 'DriverCashAdvance' ||
            expense.accountCode == 'DriverFundReturn' ||
            expense.accountCode == 'TripExpenseAdvance' ||
            expense.accountCode == 'TripExpenseReturn' ||
            expense.accountCode == 'SalaryAdvance' ||
            expense.accountCode == 'Salary' ||
            expense.accountCode == 'DriverExpense'
          "
        >
          <a
            :href="'/driver/' + expense.driver_id"
            v-if="expense.driverTO && expense.driverTO.name"
            >{{ expense.driverTO.name }}<br
          /></a>

          <a
            :href="'/driver/' + expense.driver_id"
            v-if="expense.driverTO && expense.driverTO.phone"
            >{{ expense.driverTO.countryCode }} {{ expense.driverTO.phone }}<br
          /></a>

          <a
            :href="'/settings/vendor/' + expense.onBehalf"
            v-if="expense.driverTO && expense.driverTO.owner"
            >{{ expense.driverTO.owner }}<br
          /></a>
        </span>

        <span
          v-show="
            expense.accountCode != 'DriverCashAdvance' &&
            expense.accountCode != 'DriverFundReturn' &&
            expense.accountCode != 'TripExpenseAdvance' &&
            expense.accountCode != 'TripExpenseReturn' &&
            expense.accountCode != 'SupplierAdvance' &&
            expense.accountCode != 'SupplierFundReturn' &&
            expense.accountCode != 'SalaryAdvance' &&
            expense.accountCode != 'Salary'
          "
        >
          <a
            :href="'/vehicle/' + expense.vehicle_id"
            v-if="expense.vehicleTO && expense.vehicleTO.regNo"
            >{{ expense.vehicleTO.regNo }}<br
          /></a>

          <a
            :href="'/vehicle/' + expense.vehicle_id"
            v-if="expense.vehicleTO && expense.vehicleTO.phone"
            >{{ expense.vehicleTO.vehicleType }}<br
          /></a>

          <a
            :href="'/settings/vendor/' + expense.onBehalf"
            v-if="expense.vehicleTO && expense.vehicleTO.owner"
            >{{ expense.vehicleTO.owner }}<br
          /></a>
        </span>
      </td> -->

      <td>
        <z-confirm-button
          class="float-right"
          color="red lighten-1"
          x-small
          fab
          text
          :loading="loading"
          :message="$i18n.t('Do you want to delete this Expense ?')"
          @click="deleteExpense(expense._id)"
        >
          <v-icon>mdi-trash-can-outline</v-icon>
        </z-confirm-button>
        <v-btn
          class="float-right"
          text
          fab
          x-small
          color="blue"
          :to="'/expense/' + expense._id"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </td>
    </tr>
  </tbody>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component({
  name: "ExpenseRow",
  props: {
    value: {
      default: null,
    },
    refresh: {
      default: null,
    },
    _filterFor: {
      default: null,
    },
  },
})
export default class ExpenseRow extends Vue {
  expense = null;
  limit = 2;

  get loading() {
    return common.loading;
  }

  getDateTitle(_for) {
    if (_for == "date") {
      let title = "Date";
      if (
        this.expense.accountCode == "DriverCashAdvance" ||
        this.expense.accountCode == "TripExpenseAdvance" ||
        this.expense.accountCode == "SupplierAdvance"
      ) {
        title = "Cash Advance Date";
      } else if (
        this.expense.accountCode == "DriverFundReturn" ||
        this.expense.accountCode == "TripExpenseReturn" ||
        this.expense.accountCode == "SupplierFundReturn"
      ) {
        title = "Fund Return Date";
      } else if (
        this.expense.accountCode == "DriverExpense" ||
        this.expense.accountCode == "OfficeExpense" ||
        this.expense.accountCode == "VehicleExpense"
      ) {
        title = "Payment Date";
      } else if (this.expense.accountCode == "ArticlePurchase") {
        title = "Purchase Date";
      } else if (this.expense.accountCode == "Salary") {
        title = "Salary Date";
      } else if (this.expense.accountCode == "SalaryAdvance") {
        title = "Advance Salary Date";
      } else if (this.expense.accountCode == "Rent") {
        title = "Rent Date";
      }

      return title;
    } else if (_for == "affectFrom") {
      let title = "Start Date";
      if (
        this.expense.accountCode == "VehicleExpense" &&
        (this.expense.expenseType == "Maintenance" ||
          this.expense.expenseType == "Repair")
      ) {
        title = "Service Start Date";
      } else if (
        (this.expense.accountCode == "VehicleExpense" ||
          this.expense.accountCode == "DriverExpense") &&
        this.expense.expenseType == "Insurance"
      ) {
        title = "Insurance Start Date";
      } else if (
        (this.expense.accountCode == "VehicleExpense" ||
          this.expense.accountCode == "DriverExpense") &&
        this.expense.expenseType == "Permits"
      ) {
        title = "Permit Start Date";
      } else if (
        this.expense.accountCode == "VehicleExpense" &&
        this.expense.expenseType == "Fitness"
      ) {
        title = "Fitness Start Date";
      } else if (
        this.expense.accountCode == "VehicleExpense" &&
        this.expense.expenseType == "PUC"
      ) {
        title = "PUC Start Date";
      } else if (
        this.expense.accountCode == "VehicleExpense" &&
        this.expense.expenseType == "Road Tax"
      ) {
        title = "Road Tax Start Date";
      }

      return title;
    } else if (_for == "expiry") {
      let title = "End Date";
      if (
        this.expense.accountCode == "VehicleExpense" &&
        (this.expense.expenseType == "Maintenance" ||
          this.expense.expenseType == "Repair")
      ) {
        title = "Service End Date";
      } else if (
        (this.expense.accountCode == "VehicleExpense" ||
          this.expense.accountCode == "DriverExpense") &&
        this.expense.expenseType == "Insurance"
      ) {
        title = "Insurance End Date";
      } else if (
        (this.expense.accountCode == "VehicleExpense" ||
          this.expense.accountCode == "DriverExpense") &&
        this.expense.expenseType == "Permits"
      ) {
        title = "Permit End Date";
      } else if (
        this.expense.accountCode == "VehicleExpense" &&
        this.expense.expenseType == "Fitness"
      ) {
        title = "Fitness End Date";
      } else if (
        this.expense.accountCode == "VehicleExpense" &&
        this.expense.expenseType == "PUC"
      ) {
        title = "PUC End Date";
      } else if (
        this.expense.accountCode == "VehicleExpense" &&
        this.expense.expenseType == "Road Tax"
      ) {
        title = "Road Tax End Date";
      }

      return title;
    }

    return "Date";
  }

  getTitle() {
    let title = "Title";
    if (this.expense.expenseType == "Maintenance") {
      title = "Service No";
    } else if (this.expense.expenseType == "Repair") {
      title = "Repair No";
    } else if (this.expense.expenseType == "Insurance") {
      title = "Insurance No";
    } else if (this.expense.expenseType == "PUC") {
      title = "PUC No";
    } else if (this.expense.expenseType == "Road Tax") {
      title = "Road Tax";
    } else if (this.expense.expenseType == "Repair") {
      title = "Repair No";
    } else if (this.expense.expenseType == "Permits") {
      title = "Permits";
    } else if (this.expense.expenseType == "Fitness") {
      title = "Fitness";
    } else if (this.expense.expenseType == "Repair") {
      title = "Repair No";
    }

    return title;
  }

  getParticulars() {
    if (this.expense) {
      if (
        this.expense.accountCode == "VehicleExpense" ||
        this.expense.accountCode == "DriverExpense"
      ) {
        return this.expense.expenseType;
      } else {
        let temp = "";
        if (this.expense.items) {
          for (let i = 0; i < this.expense.items.length; i++) {
            temp = temp + this.expense.items[i].title + ",";
          }
        }
        if (temp) {
          temp = temp.slice(0, -1);
        }
        return temp;
        //  else if (this.expense.accountCode == "ArticlePurchase" && this.expense.articles) {
        //   for (let i = 0; i < this.expense.articles.length; i++) {
        //     temp = temp + this.expense.items[i].title + ",";
        //   }
        // }
      }
    }
  }

  async deleteExpense(expense_id) {
    common.setLoading(true);
    try {
      await doGet("/api/expense/" + expense_id + "/delete");
      common.showMessage("Deleted Successfully");
      await this.refresh(1);
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  zoneList = [];
  async mounted() {
    if (this.value) {
      this.expense = this.value;
    }
  }

  @Watch("value")
  onValueChange(val) {
    this.expense = val;
  }

  formatDate(date) {
    if (date) {
      const dateStr = date.toString();
      return (
        dateStr.substring(6, 8) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }
}
</script>


<style scoped>
.tbody {
  height: 30px;
}
.tbody tr td {
  padding: 0 2px !important;
  cursor: pointer;
}

.tbody tr td .v-input--checkbox {
  padding: 0;
  height: 30px;
  margin-top: 8px;
}

.isActive,
.isActive:hover {
  background-color: #b2dfdb !important;
}
</style>